export const BOOKING_RESIZE_MESSAGE_TYPE = 'pooldial:booking:resize';

export const isBookingEmbedMode = (search: string): boolean =>
  new URLSearchParams(search).get('embed') === '1';

export const createBookingResizeMessage = (slug: string, height: number) => ({
  source: 'pooldial-booking',
  type: BOOKING_RESIZE_MESSAGE_TYPE,
  slug,
  height: Math.ceil(height),
});
